import Styled from 'styled-components';

export const ListNumberElement = Styled.li`
  margin-bottom: 1em;
  color: ${({ theme: { text } }) => text.colorText};
  position: relative;

  &::before {
    counter-increment: decimal-bold;
    content: counter(decimal-bold) '.';
    font-weight: 700;
    position: absolute;
    text-align: right;
    top: 0;
    left: -1.25em;
  }
`;
ListNumberElement.displayName = 'ListNumberElement';
